
export const uploadCount = (countDict) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    const authorId = getState().firebase.auth.uid;
    const timestamp = firebase.firestore().tu.firebase_.firestore.FieldValue.serverTimestamp();
    firebase.firestore().collection('redditCount').add({
      authorId: authorId,
      countDict: countDict,
      createdAt: timestamp
    }).then(() => {
      dispatch({ type: 'CREATE_COUNT_SUCCESS' }, console.log('dispatched'));
    }).catch(err => {
      dispatch({ type: 'CREATE_COUNT_ERROR' }, console.log(err));
    });
  }
};

export const notRelevant = (restaurant, postId) => {
  return (dispatch, getState, {getFirebase}) => {
    //console.log('restaurant');
    //console.log(restaurant);
    const firebase = getFirebase();
    const userId = getState().firebase.auth.uid;
    const redditNotRelevantRef = firebase.firestore().collection('redditNotRelevant').doc(userId);

    redditNotRelevantRef.get().then((doc)=>{if (doc.exists){
      if(doc.data()[[restaurant]]){
        let newArray = doc.data()[[restaurant]];
        if(!newArray.includes(postId)){
          newArray.push(postId);  
        }
        else{
          newArray = newArray.filter(itm => itm !== postId)
        }
        redditNotRelevantRef.update({[restaurant]:newArray, userId:userId}).then(() => {
      dispatch({ type: 'NOT_RELEVANT_SUCCESS' }, console.log('not relevant success'));
    }).catch(err => {
      dispatch({ type: 'NOT_RELEVANT_ERROR' }, console.log(err));
    });}
        else {redditNotRelevantRef.update({[restaurant]:[postId], userId:userId}).then(() => {
      dispatch({ type: 'NOT_RELEVANT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'NOT_RELEVANT_ERROR' }, console.log(err));
    });}
     }
      else {
       redditNotRelevantRef.set({[restaurant]:[postId], userId:userId}).then(() => {
      dispatch({ type: 'NOT_RELEVANT_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'NOT_RELEVANT_ERROR' }, console.log(err));
    }); 
      }
  })
  }
};